/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fancy_Vast_Otter_SighInputs */

const fr_fancy_vast_otter_sigh = /** @type {(inputs: Fancy_Vast_Otter_SighInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Annuler l'abonnement`)
};

/**

* @param {Fancy_Vast_Otter_SighInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const fancy_vast_otter_sigh = /** @type {((inputs?: Fancy_Vast_Otter_SighInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fancy_Vast_Otter_SighInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_fancy_vast_otter_sigh(inputs)
});